import type { NotificationAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import UserQ from './UserQ'
import WorldQ from './WorldQ'

const NotificationQ = {
  ...makeQueryModelV2<NotificationAttributes>('notification')([
    'id',
    'key',
    'user_id',
    'related_user_id',
    'secondary_related_user_id',
    'world_id',
    'session_id',
    'series_id',
    'post_id',
    'payload',
    'notify_at',
    'clicked_at',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: NotificationQ.user_id,
    },
    World: {
      query: WorldQ,
      foreignKey: WorldQ.id,
      sourceKey: NotificationQ.world_id,
    },
  }),

  where: (
    {
      id,
      key,
      userId,
      groupBy = null,
      include = [],
      order = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      key?: string | null | SQLFragment<string>
      userId?: number | null | SQLFragment<number>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      include?: IncludeAssociations
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<NotificationAttributes> => SQL`
        FROM ${NotificationQ}
        ${includeAssociationsToSql(NotificationQ, include)}
        WHERE
            ${id != null ? SQL`${NotificationQ.id} = ${id} AND` : SQL``}
            ${userId != null ? SQL`${NotificationQ.user_id} = ${userId} AND` : SQL``}
            ${key != null ? SQL`${NotificationQ.key} = ${key} AND` : SQL``}
            ${paranoid ? SQL`${NotificationQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default NotificationQ
